import { useMutation, useQueryClient } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

import { TRANSFER_MISSING_TRAYS_QUERY_KEY } from './useTransferMissingTraysQuery';
import { TRANSFER_STATS_QUERY_KEY } from './useTransferStatsQuery';
import { TRANSFER_TRAY_LIST_QUERY_KEY } from './useTransferTrayListQuery';

/**
 * This is to track the mark tray missing mutation keys in react query cache.
 */
const MUTATE_TRAY_MISSING = 'mark-tray-missing-mutation-key';

interface IUseMarkTrayMissingMutationProps {
  onSuccessCallback?: () => void;
}

/**
 * React Query mutation function for mark a tray as missing
 */
export const useMarkTrayMissingMutation = ({
  onSuccessCallback,
}: IUseMarkTrayMissingMutationProps) => {
  const queryClient = useQueryClient();
  const {
    data,
    error,
    isError,
    isPending,
    mutate: markTrayAsMissing,
    reset: resetMarkTrayAsMissingMutation,
  } = useMutation({
    mutationKey: [MUTATE_TRAY_MISSING],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.markTrayMissing,
    onSuccess: async () => {
      // Invalidate queries individually for better reliability
      await queryClient.invalidateQueries({
        queryKey: [TRANSFER_TRAY_LIST_QUERY_KEY],
        exact: false,
      });

      await queryClient.invalidateQueries({
        queryKey: [TRANSFER_MISSING_TRAYS_QUERY_KEY],
        exact: false,
      });

      await queryClient.invalidateQueries({
        queryKey: [TRANSFER_STATS_QUERY_KEY],
        exact: false,
      });

      onSuccessCallback?.();
    },
  });

  return {
    data,
    error,
    isError,
    isPending,
    markTrayAsMissing,
    resetMarkTrayAsMissingMutation,
  };
};
